// removed by extract-text-webpack-plugin
module.exports = {"container":"Charts-container","wide":"Charts-wide","chart":"Charts-chart","usageMessage":"Charts-usageMessage"};